import * as React from 'react';
import { Button } from '@fluentui/react-components';
import { ChevronDown20Regular, ChevronRight20Regular } from '@fluentui/react-icons';
import { lightThemeColors } from '../common/themes';

const TabButton: React.FC<{
  label: string,
  expanded?: boolean,
  count?: number,
  highlighted?: boolean,
  onClick: () => void,
}> = ({
  label,
  expanded,
  count,
  highlighted,
  onClick,
}) => (
  <Button
    onClick={onClick}
    icon={
      expanded ? <ChevronDown20Regular /> : <ChevronRight20Regular />
    }
    iconPosition="after"
    style={{ backgroundColor: expanded ? '#e0e0e0' : undefined }}
  >
    {label}
    {
      count !== undefined && count > 0 && (
        <div style={{
          marginLeft: 8,
          padding: 4,
          fontSize: 10,
          color: 'white',
          backgroundColor: highlighted ? lightThemeColors.alarm : lightThemeColors.primary,
          borderRadius: 999,
          minWidth: 18,
          height: 18,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>{count}</div>
      )
    }
  </Button>
);

export default TabButton;
